<template>
  <div id="home" class="yiyuan">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style lang="scss">
  .yiyuan {
    .el-carousel {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      .el-carousel__container {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
<style scoped lang="scss">
#home {
  width: 100%;
  height: 100%;
  position: relative;
  .background, .background1 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue